<template>
  <div class="hold-transition register-page" style="height: 100%;">
    <DxLoadPanel
      :visible="loadingVisible"
      :show-indicator="showIndicator"
      :show-pane="showPane"
      :shading="shading"
      :close-on-outside-click="closeOnOutsideClick"
      shading-color="rgba(0,0,0,0.4)"
    />
    <div class="register-box" style="margin-top: 20px;width: 900px;">
      <div class="register-logo">
        <!--<img src="http://arendal.com.mx/wp-content/uploads/2018/06/logo13.png" alt="Arendal" />-->
        <img src="@/assets/logoArendal.png" alt="Arendal" />
      </div>
      <div class="row" style="text-align:center;">
        <section class="content container-fluid">
          <div class="box col-sm-12 col-md-8 col-xs-8 col-lg-8" style="margin-bottom: 5px;">
            <div class="form-horizontal">
              <div class="box-body" v-if="validToken">
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                    <div class="col-sm-2">
                      <span class="span-label" style="padding-top: 0px;">Proveedor</span>
                    </div>
                    <div class="col-sm-10">
                      <div class="value">
                        <DxTextBox
                          v-model="selProveedor"
                          placeholder="Proveedor"
                          :max-length="80"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                    <span class="col-sm-2 span-label" style="padding-top: 0px;">Nombres</span>
                    <div class="col-sm-10">
                      <div class="value">
                        <DxTextBox
                          v-model="selNombre"
                          placeholder="Nombres"
                          :max-length="80"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                    <span class="col-sm-2 span-label" style="padding-top: 0px;">Apellidos</span>
                    <div class="col-sm-5">
                      <DxTextBox
                        v-model="selApellidoP"
                        placeholder="Ap. Paterno"
                        :max-length="80"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-sm-5">
                      <DxTextBox
                        v-model="selApellidoM"
                        placeholder="Ap. Materno"
                        :max-length="80"
                        :disabled="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                    <span class="col-sm-2 span-label" style="padding-top: 0px;">Contacto</span>
                    <div class="col-sm-10">
                      <div class="value">
                        <DxTextBox
                          v-model="selCorreoContacto"
                          placeholder="correo@empresa.com"
                          :max-length="80"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                    <span class="col-sm-2 span-label" style="padding-top: 0px;">Teléfono</span>
                    <div class="col-sm-10">
                      <div class="value">
                        <DxTextBox
                          v-model="selTelefono"
                          :mask-rules="rules"
                          mask="(X00) 000-0000"
                          :max-length="80"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top:5px">
                  <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                    <span class="col-sm-2 span-label" style="padding-top: 0px; vertical-align: top;">Contraseña</span>
                    <div class="col-sm-7">
                      <div class="value">
                        <!--<DxTextBox
                          id="textPSWD"
                          mode="password"
                          placeholder="Contraseña"
                          v-model="selContraseña"
                          :disabled="sendingForm"
                        />
                        <p>{{ answer }}</p>
                         <label for="password">Password</label>-->
                          <input id="textPSWD" type="password" :disabled="sendingForm" v-model="selContrasena" style="width: 100%;outline: none;font-size: .75em;padding: 0px 5px 2px 5px;" />
                          <password-meter :password="selContrasena" @score="onScore" />
                      </div>
                    </div>
                    <span class="span-label col-sm-3" v-if="!selContrasena"></span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="score === 0 && selContrasena">Muy Poco segura</span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="score === 1 && selContrasena">Muy Poco segura</span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="score === 2 && selContrasena">Poco segura</span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="score === 3 && selContrasena">Poco segura</span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="score === 4 && selContrasena">Segura</span>
                  </div>
                </div>
                <div class="row" style="margin-top:5px">
                  <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                    <span class="col-sm-2 span-label" style="padding-top: 0px; vertical-align: top;">Confirmar</span>
                    <div class="col-sm-7">
                      <div class="value">
                        <!--<DxTextBox
                          id="textCPSWD"
                          mode="password"
                          placeholder="Confirmar Contraseña"
                          v-model="selConfirmarContrasena"
                          :disabled="sendingForm"
                          @value-changed="depCContraseña($event)"
                        />-->
                        <input id="textCPSWD" type="password" :disabled="sendingForm" v-model="selConfirmarContrasena" style="width: 100%;outline: none;font-size: .75em;padding: 0px 5px 2px 5px;" />
                        <password-meter :password="selConfirmarContrasena" @score="onScoreC" />
                      </div>
                    </div>
                    <span class="span-label col-sm-3" v-if="!selConfirmarContrasena"></span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="scorec === 0 && selConfirmarContrasena">Muy Poco segura</span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="scorec === 1 && selConfirmarContrasena">Muy Poco segura</span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="scorec === 2 && selConfirmarContrasena">Poco segura</span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="scorec === 3 && selConfirmarContrasena">Poco segura</span>
                    <span class="span-label col-sm-3" style="text-align: center !important;padding: 0px;" v-if="scorec === 4 && selConfirmarContrasena">Segura</span>
                  </div>
                </div>
                <div class="row" style="margin-top:5px" v-if="score !== scorec || score !== 4 || scorec !== 4 || selContrasena !== selConfirmarContrasena">
                  <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px; background: rgb(237, 249, 183) none repeat scroll 0% 0%;border: 1px solid #ccc !important;">
                    <span class="col-sm-12 span-label" style="text-align:center; padding-top: 5px; vertical-align: top;font-weight: initial;font-size: .91em;padding-bottom: 5px;" v-if="selContrasena !== selConfirmarContrasena && (selContrasena || selConfirmarContrasena)"><b style="color: rgb(43, 43, 43); font-weight: revert; text-decoration: underline rgb(255, 114, 107) 2px;">Las contraseñas no coinciden.</b></span>
                    <span class="col-sm-12 span-label" style="padding-top: 5px; vertical-align: top;font-weight: initial;font-size: .91em;padding-bottom: 5px;">Nota: Para mayor seguridad te recomendamos que utilices 8 ó más caracteres, al menos un número y un caracter especial, hasta que la contraseña sea <b style="color: rgb(0, 0, 0); font-weight: bold;text-decoration: underline 2px rgb(53, 204, 98);">segura</b></span>
                  </div>
                </div>
                <div class="row" style="margin-top:15px;" v-if="sendingForm==false">
                  <b-button size="sm" variant="primary" style="margin:auto;" @click="enviar()">
                    Enviar
                  </b-button>
                </div>
                <div class="row" style="margin-top:15px;">
                  <div class="col-sm-11" style="margin: auto;text-align: left;font-size: .8em;border: solid thin;">
                    Una vez confirmado, puedes entrar en el portal <router-link class="text-center" to="/" style="color:#4141bd !important;">https://proveedores.arendal.com.mx</router-link> y accesar con tu correo y contraseña.
                  </div>
                </div>
              </div>
              <div class="box-body" v-else-if="validToken === false">
                <div class="row">
                  <div class="col-sm-12">
                    <label>{{Estatus}}</label>
                  </div>
                  <div class="col-sm-12">
                    <label style="font-weight: initial;">{{Message}}</label>
                  </div>
                  <div class="col-sm-12">
                    <label style="font-weight: initial;">Favor contactar al administrador.</label>
                  </div>
                </div>
              </div>
              <div class="box-body" v-else>
                <div class="row">
                  <div class="col-sm-12" style="padding: 20px; text-align: center; color: #888;">
                    <i class="fa fa-spinner fa-spin" style="font-size: 24px;"></i>
                    <p style="margin-top: 10px;">Cargando...</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>  
      </div>
    </div>
  </div>
</template>


<script>

function verifyPassword(pswd = null, cpswd = null, sending=null, scope=null, scopec=null) {
  var Upper = false;
  var Lower = false;
  var Numbe = false;
  var element;
  var stringRequired="";
  console.log(pswd)
  console.log(cpswd)
  console.log(scope)
  console.log(scopec)
  if(pswd){
    for (var i = 0; i < pswd.length; i++) {
      if(!isNaN(parseInt(pswd.charAt(i)))){
        Numbe=true;
      }else{
        if(pswd.charAt(i)===pswd.charAt(i).toLowerCase()){
          Lower=true;
        }
        if(pswd.charAt(i)===pswd.charAt(i).toUpperCase()){
          Upper=true;
        }
      }
    }
    //!console.log(Lower);
    //!console.log(Upper);
    //!console.log(Numbe);
    var notificacion = '';
    notificacion+=(pswd.length<=7)?'Mínimo 8 caracteres, ':'';
    notificacion+=(Lower)?'':'Mínimo un una minúscula, ';
    notificacion+=(Upper)?'':'Mínimo un una mayúscula, ';
    notificacion+=(Numbe)?'':'Al menos un número, ';
    notificacion+=(notificacion)?'Al menos un caracter especial, ':'';
    notificacion+=(scope>=4)?'':'La contraseña no es segura.';
    
    if(notificacion){
      element = document.getElementById("textPSWD");
      element.classList.add("inputError");
      element.classList.remove("inputOk");
      notify('La contraseña requiere: ' + notificacion.substring(0,notificacion.length-2)+'.', 'error', 1500);
    }else{
      element = document.getElementById("textPSWD");
      element.classList.remove("inputError");
      element.classList.add("inputOk");
    }
  }else{
    element = document.getElementById("textPSWD");
    element.classList.remove("inputError");
    element.classList.remove("inputOk");
    stringRequired+="- Contraseña ";
  }
  var coincidir='';
  if(cpswd){
    if(cpswd!==pswd){
      element = document.getElementById("textCPSWD");
      element.classList.add("inputError");
      element.classList.remove("inputOk");
      notify('- Las contraseñas no coinciden ', 'error', 2000);
      coincidir='- Contraseñas no coinciden';
    }else{
      element = document.getElementById("textCPSWD");
      element.classList.remove("inputError");
      element.classList.add("inputOk");
    }
  }else{
    stringRequired+="- Confirmación de contraseña";
  }
  stringRequired+=(coincidir)?coincidir:'';
  if(scope>=4 || scopec>=4){
    stringRequired+="";
  }else{
    stringRequired+="- Contraseña no segura";
  }
  stringRequired+=(stringRequired)?"   ":"";
  console.log("'"+stringRequired+"'")
  if(stringRequired && sending){
    notify('Se requiere ' + stringRequired.substring(0,stringRequired.length-3)+'.', 'error', 5000);
  }
  stringRequired="";
  //La contraseña requiere: La contraseña no es segur.
  if(Lower && Upper && Numbe && pswd.length>=8 && cpswd===pswd && scope>=4 && scopec>=4){
    return true;
  }else{
    return false;
  }
}

import apiClient from '@/services/apiClient';
import md5 from 'js-md5';
import notify from'devextreme/ui/notify';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import DxTextBox from 'devextreme-vue/text-box';
import passwordMeter from "vue-simple-password-meter";


import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';

export default {
  components:{
    DxLoadPanel,
    DxTextBox,
    passwordMeter
  },
  data(){
    return{
      loadingVisible: false,
      showIndicator: true,
      shading: true,
      showPane: true,
      closeOnOutsideClick: false,
      showSecondBoxInfo:false,

      Id_ProveedorUsuarioInvitacion:null,
      selProveedor:null,
      selNombre:null,
      selApellidoP:null,
      selApellidoM:null,
      selCorreoContacto:null,
      selTelefono:null, rules: { 'X': /[02-9]/ },
      selContrasena:null,
      selConfirmarContrasena:null,
      validToken:null,
      Estatus:null,
      Message:null,
      sendingForm:false,
      score: null,
      scorec: null
    }
  },
  created: function(){
    var that = this;
    console.log(this.$route.params.token);
    if(this.$route.params.token){
      that.loadingVisible = true;
      apiClient.post('/api/Proveedores/InvitacionProveedor', { Token: that.$route.params.token, FormatoXML: false })
      .then(function (response) {
        console.log(response);
        var datos = response.data[0];
        if(datos.Estatus=='Error'){
          that.validToken=false;
          that.Estatus='Invitación no encontrada';
          that.Message='La invitación no fue encontrada o ya ha sido aceptada.';
          //that.Estatus=datos.Estatus;
          //that.Message=datos.Mensaje;
        }else{
          that.validToken=true;
          that.Id_ProveedorUsuarioInvitacion=datos.Id_ProveedorUsuarioInvitacion;
          that.selProveedor  = datos.RazonSocial;
          that.selNombre = datos.Nombre;
          that.selApellidoP = datos.ApellidoPaterno;
          that.selApellidoM = datos.ApellidoMaterno;
          that.selCorreoContacto = datos.Correo;
          that.selTelefono = datos.Telefono;
          that.Estatus=null;
          that.Message=null;
        }
        that.loadingVisible = false;
      })
      .catch(function (error) {
        notify('Error al consultar token', 'error');
        console.log('Error: ' + error);
        that.loadingVisible = false;
      });
    }else{
      notify('Lo sentimos no se encontro token valido.', 'error');
      that.$router.push({name:'Home'});
    }
  },
  name: 'Confirmacion',
  methods: {
    depContraseña:function(e){
      //console.log(e);
      verifyPassword(e.value, this.selConfirmarContrasena);
    },
    depCContraseña:function(e){
      var element;
      if(this.selContrasena!==e.value){
        element = document.getElementById("textCPSWD");
        element.classList.add("inputError");
        element.classList.remove("inputOk");
        notify('Las contraseñas no coinciden.', 'error', 5000);
      }else{
        element = document.getElementById("textCPSWD");
        element.classList.remove("inputError");
        element.classList.add("inputOk");
      }
    },
    onScore({ score, strength }) {
      console.log(score); // from 0 to 4
      console.log(strength); // one of : 'risky', 'guessable', 'weak', 'safe' , 'secure' 
      this.score = score;
    },
    onScoreC({ score, strength }) {
      console.log(score); // from 0 to 4
      console.log(strength); // one of : 'risky', 'guessable', 'weak', 'safe' , 'secure' 
      this.scorec = score;
    },
    enviar:function(){
      var that = this;
      if(this.$route.params.token){
        console.log(verifyPassword(this.selContrasena, this.selConfirmarContrasena, false, this.score, this.scorec));
        if(verifyPassword(this.selContrasena, this.selConfirmarContrasena, true, this.score, this.scorec)){
          if(this.$route.params.token){
            //alert("enviando formulario");
            that.loadingVisible = true;
            apiClient.patch('/api/Proveedores/updInvitacionConfirmar', {
              Token: that.$route.params.token,
              Contrasena: md5(that.selContrasena),
              FormatoXML: false
            }, { withLenguaje: true })
            .then(function (response) {
              console.log(response);
              var datos = response.data[0];
              if(datos.Estatus=='Error'){
                that.validToken=false;
                that.Estatus=datos.Estatus;
                that.Message=datos.Mensaje;
              }else{
                notify(datos.Mensaje,'success');
                that.sendingForm=true;
              }
              that.loadingVisible = false;
            })
            .catch(function (error) {
              notify('Error al consultar token', 'error');
              console.log('Error: ' + error);
              that.loadingVisible = false;
            });
          }else{
            notify('Lo sentimos no se encontro token valido.', 'error');
            that.$router.push({name:'Home'});
          }
        }
      }
    }
  },
  watch: {
    selContrasena(val) {
      console.log(val);
      //verifyPassword(val, this.selConfirmarContrasena);
      //this.answer = `Inputted: ${val}`;
    },
    selConfirmarContrasena(val) {
      console.log(val);
      //var element;
      if(this.selContrasena!==val){
        //element = document.getElementById("textCPSWD");
        //element.classList.add("inputError");
        //element.classList.remove("inputOk");
        //notify('Las contraseñas no coinciden.', 'error', 5000);
      }else{
        //element = document.getElementById("textCPSWD");
        //element.classList.remove("inputError");
        //element.classList.add("inputOk");
      }
      //verifyPassword(this.selContrasena, val);
      //this.answer = `Inputted: ${val}`;
    }
  }
}
</script>

<style scoped>
a{
  color: #313538 !important;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto{
  display: inline-block;
}
.span-label{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}
.dx-datagrid-headers{
  font-weight: bold;
}
.selector_action{
  height: 24px;
  padding: 0px 0px;
}
.DxDataGrid-txtbold{
  text-decoration: underline;
  color: rgb(60, 142, 190, 0.9) !important;
  font-weight: 700;
  cursor: pointer;
}
.btnSimple{
  background: rgb(60, 142, 190, 0.9) !important;
}
.box{
  box-shadow:none;
}
.checkboxTextStile{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
}
.inputError{
  border: solid thin #ff000070;
}
.inputOk{
  border: solid thin #00800082;
}
</style>